import httpCommon from '@/utils/http-common'
import { extractUserFromToken } from '@/utils/jwt'

class AuthService {
  async login(data) {
    const dataPost = { identifier: data.username, password: data.password }
    const url = `/auth/login/basic`

    const config = { method: 'post', url, data: dataPost }
    try {
      const response = await httpCommon.request(config)
      const payload = response?.data?.data

      if (payload?.access_token) {
        const userInfo = extractUserFromToken(payload.access_token)
        return {
          jwtToken: payload.access_token,
          ...userInfo,
        }
      } else {
        const message = response?.data?.message || 'Login gagal: response tidak valid'
        throw new Error(message)
      }
    } catch (err) {
      const message = err?.response?.data?.message || err.message || 'Login gagal'
      throw new Error(message)
    }
  }

  async getGoogleOAuthUrl() {
    const response = await httpCommon.get('/auth/login/oauth/google')
    const payload = response?.data?.data

    if (payload?.url) {
      return payload.url
    } else {
      throw new Error('Failed to get Google OAuth URL')
    }
  }

  async loginWithGoogleOAuth(authorizationCode) {
    try {
      const response = await httpCommon.post('/auth/login/oauth/google', {
        authorization_code: authorizationCode,
      })
      const payload = response?.data?.data

      if (payload?.access_token) {
        const userInfo = extractUserFromToken(payload.access_token)
        return {
          jwtToken: payload.access_token,
          ...userInfo,
        }
      } else {
        const message = response?.data?.message || 'Login gagal: response tidak valid'
        throw new Error(message)
      }
    } catch (err) {
      const message = err?.response?.data?.message || err.message || 'Login gagal'
      throw new Error(message)
    }
  }

  async logout(_refreshToken) {
    // return promise resolved untuk testing sukses logout
    // await httpCommon.post("/auth/logout", { refreshToken });
    return Promise.resolve({ success: true })
  }

  async forgetPassword(email) {
    await httpCommon.post('/auth/basic/forgot-password', {
      email,
    })
  }

  async resetPassword(token, password) {
    return await httpCommon.post(`/auth/basic/reset-password?token=${encodeURIComponent(token)}`, {
      newPassword: password,
    })
  }

  async getUserByToken(token) {
    return await httpCommon.get('auth/user-by-token', {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    })
  }
}

export default new AuthService()
